export const ZIPCODE_REGEXP = /^[A-Z0-9 -]*$/;
export const ZIPCODE_MIN_LENGTH = 4;
export const ZIPCODE_MAX_LENGTH = 12;

export enum ZipCodeError {
  TOO_SHORT = "tooShort",
  TOO_LONG = "tooLong",
  INVALID_CHAR = "invalidCharacters",
}

export const validateZipcode = (code: string): ZipCodeError | undefined => {
  if (code.length < ZIPCODE_MIN_LENGTH) {
    return ZipCodeError.TOO_SHORT;
  }
  if (code.length > ZIPCODE_MAX_LENGTH) {
    return ZipCodeError.TOO_LONG;
  }
  if (!ZIPCODE_REGEXP.test(code)) {
    return ZipCodeError.INVALID_CHAR;
  }
};

export enum PwdError {
  TOO_SHORT = "tooShort",
  TOO_LONG = "tooLong",
  INVALID_CHAR = "invalidCharacters",
}

const SPECIAL_CHARACTERS = "!\"$%&'()*+,-.\\/:;?@[\\\\\\]^_`{|}~";
const SMALL_LETTERS = "a-z";
const CAPITAL_LETTERS = "A-Z";
const DIGITS = "\\d";

const REQUIRED_GROUP = (charSet: string) => `(?=.*[${charSet}])`;

export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 255;

export const PASSWORD_REGEXP = new RegExp(
  "^" +
    REQUIRED_GROUP(CAPITAL_LETTERS) + // require one capital letter
    REQUIRED_GROUP(SMALL_LETTERS) + // require one small letter
    REQUIRED_GROUP(SPECIAL_CHARACTERS) + // require one special character
    `(?=^[${CAPITAL_LETTERS}${SMALL_LETTERS}${SPECIAL_CHARACTERS}${DIGITS}]+$)` + // the entire string must consist only of the following
    `.{${PASSWORD_MIN_LENGTH},${PASSWORD_MAX_LENGTH}}`, // length requirements
);

export const validatePassword = (pwd: string): PwdError | undefined => {
  if (pwd.length < PASSWORD_MIN_LENGTH) {
    return PwdError.TOO_SHORT;
  }
  if (pwd.length > PASSWORD_MAX_LENGTH) {
    return PwdError.TOO_SHORT;
  }
  if (!PASSWORD_REGEXP.test(pwd)) {
    return PwdError.INVALID_CHAR;
  }
};

export const PHONE_REGEXP = /^(\(?\+?[0-9]*\)?)?[0-9\- ()]*$/;

// according to ecomm_v1.32.wsdl
export const COMPANY_NAME_MAX_LENGTH = 35;
// according to ecomm_v1.32.wsdl
export const ADDRESS_MAX_LENGTH = 30;
// according to ecomm_v1.32.wsdl
export const CITY_MAX_LENGTH = 35;

export const HOUSENUM_MAX_LENGTH = 10;

// as requested by INC3925971
export const STREET_MAX_LENGTH = 60;

export enum CompanyNameError {
  TOO_LONG = "tooLong",
}

export const validateCompanyName = (value: string): CompanyNameError | undefined => {
  if (value.length > COMPANY_NAME_MAX_LENGTH) {
    return CompanyNameError.TOO_LONG;
  }
};

export const validateStreetName = (value: string): StreetNameError | undefined => {
  if (value.length > STREET_MAX_LENGTH) {
    return StreetNameError.TOO_LONG;
  }
};

export const validateHouseNum = (value: string): HouseNumError | undefined => {
  if (value.length > HOUSENUM_MAX_LENGTH) {
    return HouseNumError.TOO_LONG;
  }
};

export enum HouseNumError {
  TOO_LONG = "tooLong",
}

export enum StreetNameError {
  TOO_LONG = "tooLong",
}

export enum AddressError {
  TOO_LONG = "tooLong",
}

export const validateAdditionalAddress = (value: string | undefined): AddressError | undefined => {
  if (value && value.length > ADDRESS_MAX_LENGTH) {
    return AddressError.TOO_LONG;
  }
};

export enum CityError {
  TOO_LONG = "tooLong",
}

export const validateCity = (value: string): CityError | undefined => {
  if (value.length > CITY_MAX_LENGTH) {
    return CityError.TOO_LONG;
  }
};
